var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 1.75A6.75 6.75 0 0 0 5.25 8.5c0 3.39-.725 5.514-1.408 6.766a6.2 6.2 0 0 1-.918 1.296 3 3 0 0 1-.338.312l-.009.007A.75.75 0 0 0 3 18.25h18a.75.75 0 0 0 .423-1.37l-.009-.006-.063-.05a3 3 0 0 1-.275-.262 6.2 6.2 0 0 1-.918-1.296c-.683-1.252-1.408-3.376-1.408-6.766A6.75 6.75 0 0 0 12 1.75m6.842 14.234q.237.431.468.766H4.69a9 9 0 0 0 .468-.766C5.975 14.486 6.75 12.111 6.75 8.5a5.25 5.25 0 1 1 10.5 0c0 3.61.775 5.986 1.592 7.484m-7.923 5.14a.75.75 0 0 0-1.298.752 2.75 2.75 0 0 0 4.758 0 .75.75 0 1 0-1.298-.752 1.25 1.25 0 0 1-2.162 0",
    clipRule: "evenodd"
  })));
};
export default SvgNotifications;